import _ from 'lodash'
import { ActionContext } from 'vuex'
import RootState from '../state'
import CommonState, { CmNotification } from './state'
import { Mutations } from './helpers'
import { AddNotificationRequest } from './mutations'

type CommonContext = ActionContext<CommonState, RootState>

export async function addNotification(context: CommonContext, notification: string | AddNotificationRequest): Promise<void> {
  const notificationImpl = _.isString(notification) ? { message: notification } : notification
  Mutations.addNotification(context, notificationImpl)
}

export async function clearNotifications(context: CommonContext): Promise<void> {
  Mutations.clearNotifications(context)
}

export async function removeNotification(context: CommonContext, notification: CmNotification | string): Promise<void> {
  Mutations.removeNotification(context, notification)
}

export async function removeNotificationByType(context: CommonContext, type: string): Promise<void> {
  Mutations.removeNotificationByType(context, type)
}

export default {
  addNotification,
  clearNotifications,
  removeNotification,
  removeNotificationByType
}
